import { useEffect, useState } from "react";
// import withLayout from "../../common/layout";
import { Container } from "../../common/layout/styels";
import { BoxDiv, DashboardSection, Tile, Title, Count, DayCell, EmployeeCell, CalendarTable } from "./styles";
import { GetIcon } from "../../../../icons";
import { useTranslation } from "react-i18next";
import ReactApexChart from "react-apexcharts";
import withLayout from "../../common/layout";
import { CaseItem, CasesContainer, NoData } from "../../../elements/list/styles";
import { getData } from "../../../../backend/api";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const Dashboard = (props) => {

  const { setLoaderBox , setMessage, user } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [t] = useTranslation();
  const [assignedReports, setAssignedReports] = useState([]);
  const [caseStats, setCaseStats] = useState(null);
  const [cases, setCases] = useState(null);

  useEffect(() => {
    document.title = `${t("dashboard")} - Whistleblowing24`;

    // Dummy assigned reports
    // setAssignedReports([
    //     {
    //         "_id": "68c94eb549bc637d3aa1933c",
    //         "ID": "42948",
    //         "location": {
    //             "_id": "68c2cc6f49bc637d3aa18fa6",
    //             "title": "Testing",
    //             "company": "68c2cc5449bc637d3aa18f90",
    //             "createdAt": "2025-09-11T13:19:43.619Z",
    //             "updatedAt": "2025-09-11T13:19:43.619Z",
    //             "__v": 0
    //         },
    //         "title": "ggggg",
    //         "description": "sdsdfsfsfsdfsfsdfsfsdf",
    //         "category": {
    //             "_id": "6899d1e2e55b1235f784f5d1",
    //             "en": "Other",
    //             "de": "Sonstige",
    //             "addedBy": "67dbb5503a1d9fb1cee83da5",
    //             "sequence": 0,
    //             "isMasterData": true,
    //             "isActive": true,
    //             "company": null,
    //             "isActiveForCompany": [
    //                 {
    //                     "companyId": "67dbbc013a1d9fb1cee83e13",
    //                     "isActive": true,
    //                     "_id": "6899d1e2e55b1235f784f5d2"
    //                 },
    //                 {
    //                     "companyId": "67dbd1813a1d9fb1cee83f38",
    //                     "isActive": true,
    //                     "_id": "6899d1e2e55b1235f784f5d3"
    //                 },
    //                 {
    //                     "companyId": "67e01e3e7dde5fadd9103dd0",
    //                     "isActive": true,
    //                     "_id": "6899d1e2e55b1235f784f5d4"
    //                 },
    //                 {
    //                     "companyId": "68357284953102274263393d",
    //                     "isActive": true,
    //                     "_id": "6899d1e2e55b1235f784f5d5"
    //                 },
    //                 {
    //                     "companyId": "68357ee1782faefabe6574fe",
    //                     "isActive": true,
    //                     "_id": "6899d1e2e55b1235f784f5d6"
    //                 }
    //             ],
    //             "createdAt": "2025-08-11T11:20:02.651Z",
    //             "updatedAt": "2025-08-11T11:20:02.651Z",
    //             "__v": 0
    //         },
    //         "nextDeadline": "2025-09-23T11:49:09.826Z",
    //         "status": "open",
    //         "company": "67e01e3e7dde5fadd9103dd0",
    //         "deleted": false,
    //         "createdAt": "2025-09-16T11:49:09.827Z",
    //         "updatedAt": "2025-09-16T11:49:09.827Z",
    //         "__v": 0
    //     },
    //     {
    //         "_id": "68a72f1408c3dc8a3d5bb4c4",
    //         "ID": "E4A39",
    //         "location": {
    //             "_id": "67e01e3f7dde5fadd9103eaf",
    //             "title": "Müller Consulting",
    //             "company": "67e01e3e7dde5fadd9103dd0",
    //             "__v": 0,
    //             "createdAt": "2025-03-23T14:44:15.048Z",
    //             "updatedAt": "2025-03-23T14:44:15.048Z"
    //         },
    //         "title": "teamleitet",
    //         "description": "hallo der teamleiter ist nicht freundlich",
    //         "category": {
    //             "_id": "6899d1e2e55b1235f784f5d1",
    //             "en": "Other",
    //             "de": "Sonstige",
    //             "addedBy": "67dbb5503a1d9fb1cee83da5",
    //             "sequence": 0,
    //             "isMasterData": true,
    //             "isActive": true,
    //             "company": null,
    //             "isActiveForCompany": [
    //                 {
    //                     "companyId": "67dbbc013a1d9fb1cee83e13",
    //                     "isActive": true,
    //                     "_id": "6899d1e2e55b1235f784f5d2"
    //                 },
    //                 {
    //                     "companyId": "67dbd1813a1d9fb1cee83f38",
    //                     "isActive": true,
    //                     "_id": "6899d1e2e55b1235f784f5d3"
    //                 },
    //                 {
    //                     "companyId": "67e01e3e7dde5fadd9103dd0",
    //                     "isActive": true,
    //                     "_id": "6899d1e2e55b1235f784f5d4"
    //                 },
    //                 {
    //                     "companyId": "68357284953102274263393d",
    //                     "isActive": true,
    //                     "_id": "6899d1e2e55b1235f784f5d5"
    //                 },
    //                 {
    //                     "companyId": "68357ee1782faefabe6574fe",
    //                     "isActive": true,
    //                     "_id": "6899d1e2e55b1235f784f5d6"
    //                 }
    //             ],
    //             "createdAt": "2025-08-11T11:20:02.651Z",
    //             "updatedAt": "2025-08-11T11:20:02.651Z",
    //             "__v": 0
    //         },
    //         "nextDeadline": "2025-09-11T12:00:00.000Z",
    //         "status": "open",
    //         "company": "67e01e3e7dde5fadd9103dd0",
    //         "deleted": false,
    //         "createdAt": "2025-08-21T14:37:08.293Z",
    //         "updatedAt": "2025-08-21T14:38:41.641Z",
    //         "__v": 0,
    //         "level": "medium"
    //     },
    //     {
    //         "_id": "68a2c9870626761d57d66a12",
    //         "ID": "90075",
    //         "location": {
    //             "_id": "67e01e3f7dde5fadd9103eaf",
    //             "title": "Müller Consulting",
    //             "company": "67e01e3e7dde5fadd9103dd0",
    //             "__v": 0,
    //             "createdAt": "2025-03-23T14:44:15.048Z",
    //             "updatedAt": "2025-03-23T14:44:15.048Z"
    //         },
    //         "title": "sdfsdfsdfsdf",
    //         "description": "sdfsdfsdfsdfsdf",
    //         "category": {
    //             "_id": "6899d226e55b1235f784f6bb",
    //             "en": "Auditing law",
    //             "de": "Wirtschaftsprüfungsrecht",
    //             "addedBy": "67dbb5503a1d9fb1cee83da5",
    //             "sequence": 0,
    //             "isMasterData": true,
    //             "isActive": true,
    //             "company": null,
    //             "isActiveForCompany": [
    //                 {
    //                     "companyId": "67dbbc013a1d9fb1cee83e13",
    //                     "isActive": true,
    //                     "_id": "6899d226e55b1235f784f6bc"
    //                 },
    //                 {
    //                     "companyId": "67dbd1813a1d9fb1cee83f38",
    //                     "isActive": true,
    //                     "_id": "6899d226e55b1235f784f6bd"
    //                 },
    //                 {
    //                     "companyId": "67e01e3e7dde5fadd9103dd0",
    //                     "isActive": true,
    //                     "_id": "6899d226e55b1235f784f6be"
    //                 },
    //                 {
    //                     "companyId": "68357284953102274263393d",
    //                     "isActive": true,
    //                     "_id": "6899d226e55b1235f784f6bf"
    //                 },
    //                 {
    //                     "companyId": "68357ee1782faefabe6574fe",
    //                     "isActive": true,
    //                     "_id": "6899d226e55b1235f784f6c0"
    //                 }
    //             ],
    //             "createdAt": "2025-08-11T11:21:10.872Z",
    //             "updatedAt": "2025-08-11T11:21:10.872Z",
    //             "__v": 0
    //         },
    //         "nextDeadline": "2025-08-25T06:34:47.836Z",
    //         "status": "open",
    //         "company": "67e01e3e7dde5fadd9103dd0",
    //         "deleted": false,
    //         "createdAt": "2025-08-18T06:34:47.836Z",
    //         "updatedAt": "2025-08-19T08:49:47.593Z",
    //         "__v": 0,
    //         "level": "low"
    //     },
    //     {
    //         "_id": "689c15c46ac730343b4fe919",
    //         "ID": "0EF47",
    //         "location": {
    //             "_id": "67e01e3f7dde5fadd9103eaf",
    //             "title": "Müller Consulting",
    //             "company": "67e01e3e7dde5fadd9103dd0",
    //             "__v": 0,
    //             "createdAt": "2025-03-23T14:44:15.048Z",
    //             "updatedAt": "2025-03-23T14:44:15.048Z"
    //         },
    //         "title": "88888888888888888888",
    //         "description": "llllllllllllllllllllllllllllllllllllll",
    //         "category": {
    //             "_id": "689992e2e072a9546f0cca3f",
    //             "en": "Procurement fraud",
    //             "de": "Beschaffungsbetrug",
    //             "addedBy": "67dbb5503a1d9fb1cee83da5",
    //             "sequence": 0,
    //             "isMasterData": true,
    //             "isActive": true,
    //             "company": null,
    //             "isActiveForCompany": [
    //                 {
    //                     "companyId": "67dbbc013a1d9fb1cee83e13",
    //                     "isActive": true,
    //                     "_id": "689992e2e072a9546f0cca40"
    //                 },
    //                 {
    //                     "companyId": "67dbd1813a1d9fb1cee83f38",
    //                     "isActive": true,
    //                     "_id": "689992e2e072a9546f0cca41"
    //                 },
    //                 {
    //                     "companyId": "67e01e3e7dde5fadd9103dd0",
    //                     "isActive": true,
    //                     "_id": "689992e2e072a9546f0cca42"
    //                 },
    //                 {
    //                     "companyId": "68357284953102274263393d",
    //                     "isActive": true,
    //                     "_id": "689992e2e072a9546f0cca43"
    //                 },
    //                 {
    //                     "companyId": "68357ee1782faefabe6574fe",
    //                     "isActive": true,
    //                     "_id": "689992e2e072a9546f0cca44"
    //                 }
    //             ],
    //             "createdAt": "2025-08-11T06:51:14.663Z",
    //             "updatedAt": "2025-08-11T06:51:14.663Z",
    //             "__v": 0
    //         },
    //         "nextDeadline": "2025-08-20T04:34:12.340Z",
    //         "status": "open",
    //         "company": "67e01e3e7dde5fadd9103dd0",
    //         "deleted": false,
    //         "createdAt": "2025-08-13T04:34:12.341Z",
    //         "updatedAt": "2025-08-13T12:54:39.052Z",
    //         "__v": 0,
    //         "level": "low"
    //     },
    // ]);

    // setCases({totalCase: 10, newCase: 2, openCase: 5, closedCase: 3});

    fetchAssignedCasesToMe();

  }, [t]);

  const fetchAssignedCasesToMe = async () => {
    try {
      setLoaderBox(true);
      const response = await getData({}, "whistleblowing/dashboard", dispatch, navigate);
      if(response.data){
        setLoaderBox(false);
        setAssignedReports(response.data.data);
        setCases(response.data.cases)
        setCaseStats({
          series: [{
            name: t("Reports"),
            data:  response.data?.chart?.chartData // dummy counts
          }],
          options: {
            chart: {
              type: 'area',
              height: 300
            },
            dataLabels: { enabled: false },
            stroke: { curve: 'smooth' },
            xaxis: {
              categories: response.data?.chart?.chartCategories,
              title: { text: t("Creation date") }
            },
            yaxis: {
              title: { text: t("Case Count") }
            },
            tooltip: { x: { format: 'dd MMM yyyy' } }
          }
        });
      }

      setLoaderBox(false);

    } catch (error) {
      console.error(error)
    }
  }

  return (
    <Container className="noshadow column">
      <DashboardSection count={2} className="one">
        
        {/* Area 1: Assigned Reports */}
        <BoxDiv className="radious">
          <div className="head">
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', fontWeight: 'bold', color: '#0C3090' }}>
              <GetIcon icon={"employees"} />
              {t("Assigned to me")}
            </div>
          </div>
          {assignedReports.length > 0 ? <BoxDiv style={{padding: "10px"}}>
                      <CalendarTable style={{overflow:"hidden"}}>
                        <thead>
                          <tr>
                            <EmployeeCell className="thead" >{t("id")}</EmployeeCell>
                            <EmployeeCell className="thead">{`${t("topic")}`}</EmployeeCell>
                            <EmployeeCell className="thead">{t("department")}</EmployeeCell>
                            <EmployeeCell className="thead">{t("category")}</EmployeeCell>
                            <EmployeeCell className="thead">{t("status")}</EmployeeCell>
                            {/* <EmployeeCell className="thead" ></EmployeeCell> */}
                          </tr>
                        </thead>
                        <tbody>
                          {assignedReports.length > 0 &&
                            assignedReports.map(
                              (r) =>
                                r && (
                                  <tr key={`whistleblowing-${r.ID}`}>
                                    <DayCell className="left top">{r?.ID}</DayCell>
                                    <DayCell className="left top">{r?.title}</DayCell>
                                    <DayCell className="left top">{r?.department?.length > 0 &&
                                      r.department.map((item, idx) => (
                                        <span key={idx}>
                                          {item.title}
                                          {idx + 1 !== r.department.length && ", "}
                                        </span>
                                      ))}</DayCell>
                                    <DayCell className="left top">{r?.category && r?.category[sessionStorage.getItem("_lang") || 'de']}</DayCell>
                                    <DayCell className="left top">{t(r?.status)}</DayCell>
                                    <DayCell onClick={()=> navigate(`/whistle?id=${r._id}`)} className="top" style={{cursor:"pointer"}}><div style={{rotate: "-90deg"}}><GetIcon icon={"down"} /></div></DayCell>
                                    
                                  </tr>
                                )
                            )}
                        </tbody>
                      </CalendarTable>
                    </BoxDiv> : <BoxDiv>
                    <NoData className="cover">{t("No cases assigned to you")}</NoData>
                  </BoxDiv>}
          {/* <div style={{ padding: "10px" }}>
            {assignedReports.length > 0 ? (
              assignedReports.map((r) => (
                <Tile key={r.id}>
                  <Title>{r.title}</Title>
                  <Count>{r.status}</Count>
                </Tile>
              ))
            ) : (
              <div>{t("No reports assigned to you")}</div>
            )}
          </div> */}
        </BoxDiv>

        {/* Area 2: Case Summary Stats */}
        <BoxDiv className="radious">
          <div className="head">
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', fontWeight: 'bold', color: '#0C3090' }}>
              <GetIcon icon={"dashboard"} />
              {t("Case Summary Statistics")}
            </div>
          </div>
          <div style={{overflowX: 'auto', padding: '20px 10px'}}>
            {cases && <CasesContainer>
                      <CaseItem>
                        <div className="num">{cases?.totalCase}</div>
                        <div>{t("Total Cases")}</div>
                      </CaseItem>
                      <CaseItem>
                        <div className="num">{cases?.newCase} / {cases?.totalCase}</div>
                        <div>{t("New case")}</div>
                      </CaseItem>
                      <CaseItem>
                        <div className="num">{cases?.openCase} / {cases?.totalCase}</div>
                        <div>{t("Open case")}</div>
                      </CaseItem>
                      <CaseItem>
                        <div className="num">{cases?.closedCase}</div>
                        <div>{t("Closed case")}</div>
                      </CaseItem>
                    </CasesContainer>}
            {caseStats ? (
              <ReactApexChart
                options={caseStats.options}
                series={caseStats.series}
                type="area"
                height={300}
              />
            ) : (
              <NoData className="cover">{t("No statistics available")}</NoData>
            )}
          </div>
        </BoxDiv>

      </DashboardSection>
    </Container>
  );
};

export default withLayout(Dashboard);
